import { useSelector } from "react-redux";
import Navbar from "../../Utils/Navbar/navbar-component";
import Toast from "../../Utils/Toast/toast-component";
import { useEffect, useState } from "react";
import Footer from "../../Utils/Footer/footer-component";
import ContactForm from "../../Utils/Forms/ContactForm/contact-form-component";
import logo from '../../Assets/ai-gen-studio.png'
import { Modal } from "../../Utils/Modal/modal-component.js";
import { LoadingAnimation, ReciploAnimation } from "../../Utils/Progress/progress-component.js";
import contactData from "../../Public/contact-data.js";
import { useRef } from "react";
import GlobalConsts from "../../Utils/Constants/GlobalConsts.js";

function Contact() {
    const user = useSelector((state) => state.auth.user);
    const theme = useSelector((state) => state.auth.theme);
    const [imageLoaded, setImageLoaded] = useState(false);
    const loading = useSelector((state) => state.loading);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [modal, setModal] = useState(false); // Default language
    const videoRef = useRef(null);
    const content = contactData.getContent();


    const handleImageLoad = () => {
        setImageLoaded(true);
    };


    const handleLanguageChange = (language) => {
        setSelectedLanguage(language);
        setModal(true);
        // console.log(`Selected Language: ${language}`);
    };

    useEffect(() => {
        videoRef.current.play().catch(error => {
            // console.error('Error attempting to play video:', error);
        });
    }, []);


    return (
        <div>
            <Toast></Toast>
            <div className="min-h-full w-full">

                <Modal expand={!modal} timeout={false} >
                    <div className="flex w-full h-full bg-white dark:bg-black flex-col justify-center">
                        <div className=" flex flex-col items-center w-full h-1/3 my-4 mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">

                            <div className="flex w-full items-center justify-center flex-row">

                                <div className="flex justify-center">
                                    <div className="flex justify-center">
                                        <div className="flex shadow-xl rounded-full aspect-[1] align-middle border-none mb-4 mx-4">
                                            <img
                                                alt="..."
                                                src={logo}
                                                style={{ objectFit: 'cover' }}
                                                className={`${imageLoaded ? 'opacity-100' : 'opacity-0'}  flex aspect-[1] rounded-full align-middle border-none  lg:h-54 lg:w-54  h-14 w-14 transition-all duration-150 `}
                                                onLoad={handleImageLoad}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <h1 className="mb-4 text-2xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">ai gen studio</h1>

                            </div>
                            <div className="flex flex-col w-3/4  lg:w-full  lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">

                                <div className="w-full sm:w-auto">
                                    <button
                                        className="w-full py-3 px-5 text-base font-bold text-center text-white rounded-lg dark:bg-blue-500 bg-blue-700 dark:hover:bg-blue-700 dark:focus:ring-gray-800 transition-all duration-150"
                                        onClick={(e) => { e.preventDefault(); handleLanguageChange('he') }}
                                    >
                                        Hebrew
                                    </button>
                                </div>
                                <div className="w-full sm:w-auto">
                                    <button
                                        className="w-full py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 transition-all duration-150"
                                        onClick={(e) => { e.preventDefault(); handleLanguageChange('en') }}
                                    >
                                        English
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <LoadingAnimation loadingMessage={loading.message} /> */}
                </Modal>

                <Navbar isAutoLogOut={false} />


                <main>
                    <div className="mx-auto lg:max-w-full sm:px-6 lg:px-8">
                        <section className="rounded-lg">
                            <div className="flex flex-col lg:flex-row">

                                {/* Image Container */}
                                <div className="lg:flex-1 lg:max-w-1/2 rounded-3xl content-center">

                                    <div className="flex justify-center items-center ">
                                        <video
                                            ref={videoRef}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                            className={`w-full h-full lg:rounded-2xl`}
                                        >
                                            <source src='https://sawpy-assets.s3.us-east-2.amazonaws.com/videos/ai_gen_studio.mp4' type="video/mp4" />
                                        </video>
                                    </div>
                                </div>

                                {/* Contact Form Container */}
                                <div className="py-8 lg:py-16 px-12 mx-auto lg:flex-1 lg:max-w-1/2">
                                    <h1 className="text-6xl font-bold tracking-tight text-blue-700 dark:text-gray-50">
                                        {contactData.getContent(selectedLanguage).title}
                                    </h1>
                                    <p className="mb-8 lg:mb-16 mt-4 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
                                        {contactData.getContent(selectedLanguage).description}
                                    </p>
                                    <ContactForm language={selectedLanguage} />
                                </div>

                            </div>
                        </section>
                    </div>
                </main>


            </div>
            <Footer />
        </div>
    );
}

export default Contact;